(() => {
  if (customElements.get('dynamic-dates')) return;

  const isWeekend = (date) => date.getDay() === 0 || date.getDay() === 6;

  const addBusinessDays = (date, days) => {
    const clone = new Date(date);

    if (days <= 0) return clone;

    let remainingDays = days;
    while (remainingDays > 0) {
      clone.setDate(clone.getDate() + 1);

      if (!isWeekend(clone)) {
        remainingDays -= 1;
      }
    }

    return clone;
  };

  const pad = (value) => String(value).padStart(2, '0');

  const getOrdinalSuffix = (day) => {
    if (day === 1 || day === 21 || day === 31) return 'st';
    if (day === 2 || day === 22) return 'nd';
    if (day === 3 || day === 23) return 'rd';
    return 'th';
  };

  class DynamicDates extends HTMLElement {
    constructor() {
      super();
      this.dateFormat = this.dataset.dateFormat;
      this.days = this.rearrangeDays((this.dataset.dayLabels || '').split(',').map((day) => day.trim()));
      this.months = (this.dataset.monthLabels || '').split(',').map((month) => month.trim());
      this.dynamicDateElements = this.querySelectorAll('[data-dynamic-date="true"]');
      this.insertDates();

      document.addEventListener('shopify:section:load', () => {
        this.insertDates();
      });
    }

    insertDates() {
      const currentDate = new Date();

      this.dynamicDateElements.forEach((element) => {
        const text = element.dataset.text || '';
        const minDays = parseInt(element.dataset.minDays, 10) || 0;
        const maxDays = parseInt(element.dataset.maxDays, 10) || 0;
        const startDate = addBusinessDays(currentDate, minDays);
        const endDate = addBusinessDays(currentDate, maxDays);

        const startText = this.formatDate(startDate);
        const endText = this.formatDate(endDate);

        element.innerHTML = text.replace('[start_date]', startText).replace('[end_date]', endText);
      });
    }

    formatDate(date) {
      const day = date.getDate();
      const month = this.months[date.getMonth()] || '';
      const weekday = this.days[date.getDay()] || '';
      const numericDay = pad(day);
      const numericMonth = pad(date.getMonth() + 1);
      const suffix = getOrdinalSuffix(day);

      switch (this.dateFormat) {
        case 'day_dd_mm':
          return `${weekday}, ${day}. ${month}`;
        case 'mm_dd':
          return `${month} ${day}${suffix}`;
        case 'dd_mm':
          return `${day}. ${month}`;
        case 'dd_mm_no_dot':
          return `${day} ${month}`;
        case 'day_dd_mm_numeric':
          return `${weekday}, ${numericDay}. ${numericMonth}.`;
        case 'dd_mm_numeric':
          return `${numericDay}. ${numericMonth}.`;
        case 'day_mm_dd':
        default:
          return `${weekday}, ${month} ${day}${suffix}`;
      }
    }

    rearrangeDays(days) {
      if (days.length < 7) return days;
      days.unshift(days[6]);
      days.length = 7;
      return days;
    }
  }

  customElements.define('dynamic-dates', DynamicDates);
})();
